export default "__VITE_ASSET__EUB1l85w__"